export default __webpack_public_path__ + "dfeef9ebc7d097eb553f8397b396ab35.png";